import { Upload } from 'antd';
import { UploadProps } from 'antd/lib/upload';
import * as React from 'react';

const Component: React.StatelessComponent<UploadProps> = props => {
  return <Upload {...props} />;
};

export default Component;
